import React, { useState } from "react";
import PasswordInput from "./PasswordInput";

export default function PasswordStep({ onSubmit, loading, error }) {
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [validationError, setValidationError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setValidationError("");
    if (password.length < 6) {
      setValidationError("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (password !== confirmation) {
      setValidationError("Las contraseñas no coinciden.");
      return;
    }

    const submittedPassword = password;
    setPassword("");
    setConfirmation("");
    await onSubmit(submittedPassword);
  };

  return (
    <div className="onboarding-card-inner">
      <div className="onboarding-step-head">
        <div>
          <h2>Actualiza tu contraseña</h2>
          <p>Elige una contraseña de al menos 6 caracteres y confírmala.</p>
        </div>
        <span className="onboarding-step-count">Paso 2 de 3</span>
      </div>

      {(validationError || error) && (
        <p className="onboarding-error" role="alert">
          {validationError || error}
        </p>
      )}

      <form className="onboarding-form" onSubmit={handleSubmit}>
        <div className="onboarding-field">
          <label htmlFor="onboarding-new-password">Nueva contraseña</label>
          <PasswordInput
            id="onboarding-new-password"
            autoComplete="new-password"
            minLength={6}
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            disabled={loading}
            showLabel="Mostrar nueva contraseña"
            hideLabel="Ocultar nueva contraseña"
          />
        </div>
        <div className="onboarding-field">
          <label htmlFor="onboarding-confirm-password">Confirma tu contraseña</label>
          <PasswordInput
            id="onboarding-confirm-password"
            autoComplete="new-password"
            minLength={6}
            required
            value={confirmation}
            onChange={(event) => setConfirmation(event.target.value)}
            disabled={loading}
            showLabel="Mostrar confirmación de contraseña"
            hideLabel="Ocultar confirmación de contraseña"
          />
        </div>
        <p className="onboarding-help">
          Al confirmar el cambio, usaremos la sesión actual para continuar con
          tu ficha.
        </p>
        <div className="onboarding-button-row">
          <span />
          <button
            className="onboarding-button onboarding-button--primary"
            type="submit"
            disabled={loading || !password || !confirmation}
          >
            {loading ? "Actualizando…" : "Actualizar y continuar"}
          </button>
        </div>
      </form>
    </div>
  );
}
